import { render, staticRenderFns } from "./Collaborators.vue?vue&type=template&id=423dcccc&scoped=true&"
import script from "./Collaborators.vue?vue&type=script&lang=js&"
export * from "./Collaborators.vue?vue&type=script&lang=js&"
import style0 from "./Collaborators.vue?vue&type=style&index=0&id=423dcccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423dcccc",
  null
  
)

export default component.exports